// src/components/NativeAuthComplete.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Toast } from 'antd-mobile';

const NativeAuthComplete = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleNativeGoogleAuth } = useAuth();
  
  useEffect(() => {
    const completeAuth = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      
      if (!token) {
        Toast.show({
          content: 'Authentication failed - No token',
          duration: 2000,
        });
        navigate('/login');
        return;
      }

      const loadingToast = Toast.show({
        icon: 'loading',
        content: 'Completing authentication...',
        duration: 0,
      });

      try {
        // Set token first
        localStorage.setItem('jwtToken', token);
        console.log('Token stored in localStorage');
        
        // Then handle the auth
        await handleNativeGoogleAuth(token);
        Toast.clear(loadingToast);
        navigate('/home');
      } catch (error) {
        console.error('Native auth completion error:', error);
        Toast.clear(loadingToast);
        Toast.show({
          content: error.message || 'Authentication failed',
          duration: 2000,
        });
        localStorage.removeItem('jwtToken');
        navigate('/login');
      }
    };

    completeAuth();
  }, [location, handleNativeGoogleAuth, navigate]);
  
  return null;
};

export default NativeAuthComplete;